import React, { useEffect, useState } from 'react';
import siteConfig from '../config/site-config';

function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  textArea.select();
  document.execCommand('copy');
  document.body.removeChild(textArea);
  return Promise.resolve();
}

function TrackerBindPage() {
  const [identity, setIdentity] = useState(null);
  const [policy, setPolicy] = useState(null);
  const [error, setError] = useState('');
  const [copied, setCopied] = useState(false);
  const token = new URLSearchParams(window.location.search).get('t') || '';

  useEffect(() => {
    if (!token) {
      setError('缺少绑定令牌');
      return;
    }
    fetch(`${siteConfig.getApiUrl()}/tracker/check?t=${encodeURIComponent(token)}`)
      .then(async (response) => {
        const data = await response.json();
        if (!response.ok || !data.success) throw new Error(data.error || '绑定令牌不可用');
        setIdentity(data.identity || data);
        setPolicy(data.policy || null);
      })
      .catch((requestError) => setError(requestError.message));
  }, [token]);

  const handleCopy = async () => {
    await copyText(token);
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <main style={{ minHeight: '100vh', padding: '24px 16px', boxSizing: 'border-box', background: '#edf7f7', fontFamily: 'system-ui, sans-serif' }}>
      <section style={{ maxWidth: 520, margin: '0 auto', padding: 24, background: '#fff', borderRadius: 12, boxShadow: '0 8px 28px rgba(0,80,80,.14)' }}>
        <h1 style={{ margin: '0 0 8px', color: '#087f7b', fontSize: 24 }}>ZHXT App 位置绑定</h1>
        <p style={{ margin: '0 0 20px', color: '#52616b' }}>此页面用于确认手机追踪身份；请在 App 中使用下方令牌。</p>
        {error && <div style={{ padding: 12, borderRadius: 6, color: '#b42318', background: '#fef3f2' }}>{error}</div>}
        {!error && !identity && <div style={{ color: '#52616b' }}>正在验证绑定令牌…</div>}
        {identity && (
          <>
            <dl style={{ margin: '0 0 20px', lineHeight: 1.8 }}>
              <div><dt style={{ display: 'inline', fontWeight: 700 }}>姓名：</dt><dd style={{ display: 'inline', margin: 0 }}>{identity.name}</dd></div>
              <div><dt style={{ display: 'inline', fontWeight: 700 }}>小组：</dt><dd style={{ display: 'inline', margin: 0 }}>{identity.group_name}</dd></div>
              {identity.org_name && <div><dt style={{ display: 'inline', fontWeight: 700 }}>组织：</dt><dd style={{ display: 'inline', margin: 0 }}>{identity.org_name}</dd></div>}
              {identity.note && <div><dt style={{ display: 'inline', fontWeight: 700 }}>备注：</dt><dd style={{ display: 'inline', margin: 0 }}>{identity.note}</dd></div>}
              <div><dt style={{ display: 'inline', fontWeight: 700 }}>当前模式：</dt><dd style={{ display: 'inline', margin: 0 }}>{(policy?.track_mode || identity.track_mode) === 'boosted' ? '加强追踪' : '省电追踪'}</dd></div>
              <div>
                <dt style={{ display: 'inline', fontWeight: 700 }}>绑定状态：</dt>
                <dd style={{ display: 'inline', margin: 0 }}>
                  {identity.bound || identity.first_used_at ? (
                    <span style={{ color: '#065f5b', fontWeight: 700 }}>已绑定{identity.first_used_at ? `（${new Date(identity.first_used_at).toLocaleString()}）` : ''}</span>
                  ) : (
                    <span style={{ color: '#92400e', fontWeight: 600 }}>待绑定（App 首次上报位置后生效）</span>
                  )}
                </dd>
              </div>
              {identity.device_unique_id && (
                <div><dt style={{ display: 'inline', fontWeight: 700 }}>设备 ID：</dt><dd style={{ display: 'inline', margin: 0, wordBreak: 'break-all' }}>{identity.device_unique_id}</dd></div>
              )}
            </dl>
            <label style={{ display: 'block', marginBottom: 6, fontWeight: 700 }}>绑定令牌</label>
            <textarea readOnly value={token} style={{ width: '100%', minHeight: 86, padding: 10, boxSizing: 'border-box', border: '1px solid #b9d8d6', borderRadius: 6, resize: 'none' }} />
            <button onClick={handleCopy} style={{ width: '100%', marginTop: 12, padding: '11px 16px', color: '#fff', background: '#087f7b', border: 0, borderRadius: 6, cursor: 'pointer', fontWeight: 700 }}>
              {copied ? '已复制令牌' : '复制绑定令牌'}
            </button>
          </>
        )}
      </section>
    </main>
  );
}

export default TrackerBindPage;
